import useStyles from 'components/molcules/N1SummaryReport/useStyles'
import SubTitle from 'components/Text/SubTitle'
import {useTranslation} from 'react-i18next'
import React from 'react'

interface HRVSummaryAutoNervousSystemProps {
  customerFirstName: string
  customerLastName: string
  balanceOpinion: string
  balanceCircularImagePath: string
}

export default function HRVSummaryAutoNervousSystemAPI(
  props: HRVSummaryAutoNervousSystemProps,
) {
  const {
    balanceCircularImagePath,
    balanceOpinion,
    customerFirstName,
    customerLastName,
  } = props
  const classes = useStyles()
  const {t, i18n} = useTranslation()
  const koreanCustomerName = `${customerLastName} ${customerFirstName}`
  const englishCustomerName = `${customerFirstName} ${customerLastName}`

  return (
    <div className={classes.hrv}>
      <SubTitle className='ReportTitle'>
        1. IHRVSummaryReportAutonomicNervousSystemTitleAPI
      </SubTitle>
      <div className={classes.hrvAutoNervous}>
        <img
          className='CircularChartImage'
          src={balanceCircularImagePath}
          alt=''
        />
        <div>
          <div className='Opinion'>IOpinionOfUserAPI</div>
          <div className='About'>
            IHRVSummaryReportAutonomicNervousSystemAboutAPI
          </div>
          <div className='Balance'>{balanceOpinion}</div>
          <div className='Analysis'>
            <div className='Sympathetic'>
              <div>
                <span className='Label'>ISympatheticAPI</span>{' '}
                <span className='Label-append'>IWhenDominantAPI</span>
              </div>
              <div>ISymptomOfSympatheticDominantAPI</div>
            </div>

            <div className='Parasympathetic'>
              <div>
                <span className='Label'>IParasympatheticAPI</span>{' '}
                <span className='Label-append'>IWhenDominantAPI</span>
              </div>
              <div>ISymptomOfParasympatheticDominantAPI</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
